// As defined in https://github.com/mozilla/pdf.js/blob/master/src/shared/util.js#L378-L381

const PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2,
};

export default PasswordResponses;
